import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from '@repo/toast';
import { TestId } from '@repo/test-id';
import { tr } from '@repo/locale';

import { useParkingCreateStore } from '@shared/stores/useParkingCreateStore';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function DraftExistsGuard() {
  const id = useParkingCreateStore((state) => state.ownParking.id);
  const navigate = useNavigate();
  const hasDraft = !!id;

  useEffect(() => {
    if (!hasDraft) {
      const testId = TestId.root('draftExistsGuardError');
      toast.danger(tr('owned_parking_create:spots_creator.unavailable'), testId);
      navigate(ROUTE_PATHS[RouteName.MY_PARKING_CREATE], { replace: true });
    }
  }, [hasDraft, navigate]);

  if (!hasDraft) {
    return null;
  }

  return <Outlet />;
}
